import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import { LoginState } from '../global/LoginState'
import { UserState } from '../global/UserState'
import { roleRoutes, defaultRoute } from '../default'

const TokenChecker = () => {
  const [, setLoginState] = useRecoilState(LoginState)
  const [, setUserState] = useRecoilState(UserState)
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    const token = localStorage.getItem('token')
    const role = localStorage.getItem('role')
    const unit = localStorage.getItem('unit')
    const subUnit = localStorage.getItem('subUnit')
    const username = localStorage.getItem('user')

    if (token) {
      setLoginState({ isLoggedIn: true, role })
      setUserState({ username, role, unit, subUnit})
      // Redirect if user is at the landing/login page
      if (location.pathname === '/' || location.pathname === '/sign-in') {
        navigate(roleRoutes[role] || defaultRoute, { replace: true })
      }
    } else {
      setLoginState({ isLoggedIn: false, role: null })
      setUserState(null)
      localStorage.clear()
    }
  }, [location.pathname, navigate, setLoginState, setUserState])

  return null
}

export default TokenChecker
